import React from "react";
import avatar from "../../assets/brand/ada-avatar-trend.svg";

// AdA's circle: soft violet circle, ink trend line, purple dot (Scott, 15 Oct
// 2026). Reused wherever AdA appears (the Observed strip now; the AdA chat
// and upsell prompts later). size: in rem, so it scales with the app.
export default function AdaAvatar({ size = 1.5, title = "AdA", className = "" }) {
  return (
    <img
      src={avatar} alt={title} title={title}
      className={`shrink-0 rounded-full ${className}`}
      style={{ width: `${size}rem`, height: `${size}rem` }}
    />
  );
}
